import React, { useContext, useEffect } from "react";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import useAuth from "../../../hooks/useAuth";

const Protected = ({ allowedRoles }) => {
  const { authenticated } = useAuth();
  const location = useLocation();
  useEffect(() => {
    // console.log(
    //   authenticated?.roles?.find((role) => allowedRoles?.includes(role))
    // );
  }, []);
  return authenticated?.roles?.find((role) => allowedRoles?.includes(role)) ? (
    <Outlet />
  ) : authenticated?.user ? (
    <Navigate to="/unAuthorized" state={{ from: location }} replace />
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

export default Protected;
